var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParasutLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1360.6 935.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b34439;\n      }\n\n      .cls-2 {\n        fill: #f15e4f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "katman_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1-2",
    "data-name": "katman_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M967,322.4c152.1,0,277.9,119.5,286.6,271.6-8.6-310.1-263.6-556.4-573.6-554.6-314.6-1.8-571.2,251.5-573.6,566.1v2.9c6.3,158.5,139.5,281.9,298,275.5,149.8-5.7,269.3-125.7,275.5-275.5,0-157.8,128.6-285.9,287.1-285.9h-.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 967,
    cy: 608.9,
    r: 287.1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParasutLogo);
export default __webpack_public_path__ + "static/media/parasut_logo.6ca769766ded292a5ec94210a4c4eb4a.svg";
export { ForwardRef as ReactComponent };